import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useCookies } from 'react-cookie';
import CircleIcon from '~/elements/CircleIcon';
import Loader from '~/elements/Loader';
import { useFingerPrint } from '~/components/FingerPrintProvider';
import { submitFeedback } from '~/api/NewViewer';
import { $shouldDisplayFeedbackAtom } from '~/atoms';
import { FEEDBACK_FORM_COOKIE_LIFESPAN } from '~/constants/general';
import Api from '~/api';
import { Body, Button, CloseButton, Container, Form, Header, HiddenContainer, HR, Question, RatingContainer, RatingBoxContainer, RatingBox, RatingLabel, SubTitle, Textarea, Title, } from './feedbackPopup.styles';
import { images, theme } from '~/themes/variables';
const schema = yup.object({
    score: yup.number().required().min(1).max(5),
    feedback: yup.string().optional(),
});
const FeedbackPopup = ({ closePopup }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [selectedRating, setSelectedRating] = useState(null);
    const { fingerprint } = process.env.NODE_ENV === 'test'
        ? { fingerprint: 'mockFingerPrint' }
        : useFingerPrint();
    const cookieName = `OneroomFeedback-${eventDataProps.data.id}`;
    const [, setCookie] = useCookies([cookieName]);
    const { register, handleSubmit, setValue } = useForm({
        resolver: yupResolver(schema),
    });
    const handleRatingClick = (rating) => {
        setSelectedRating(rating);
        setValue('score', rating);
    };
    const handleClosePopup = useCallback(() => {
        setCookie(cookieName, true, { maxAge: FEEDBACK_FORM_COOKIE_LIFESPAN });
        $shouldDisplayFeedbackAtom.set(false);
        document.body.style.overflow = 'auto';
        closePopup();
        Api.Analytics.closeFeedbackForm();
    }, []);
    const onSubmit = handleSubmit(async (data) => {
        setIsLoading(true);
        const result = await submitFeedback(fingerprint, data.score, data.feedback);
        if (result) {
            $shouldDisplayFeedbackAtom.set(false);
            document.body.style.overflow = 'auto';
            setCookie(cookieName, true, { maxAge: FEEDBACK_FORM_COOKIE_LIFESPAN });
            closePopup();
            Api.Analytics.submitFeedbackForm(Boolean(data.feedback));
        }
        else {
            console.log('error');
            Api.Analytics.errorFeedbackForm();
        }
        setIsLoading(false);
    });
    useEffect(() => {
        document.body.style.overflow = 'hidden';
        Api.Analytics.openFeedbackForm();
        register('score');
    }, []);
    return (_jsx(Container, { children: _jsxs(Form, { onSubmit: onSubmit, children: [_jsx(CloseButton, { onClick: handleClosePopup, children: _jsx("img", { src: images.closeIcon }) }), _jsx(Header, { children: _jsx(CircleIcon, { size: 50, icon: images.feedbackIcon, iconBG: theme.colors.brandSecondary }) }), _jsxs(Body, { children: [_jsx(Title, { children: "Your Feedback" }), _jsx(Question, { children: "How would you rate your experience watching todays service?" }), _jsx(RatingContainer, { children: Array.from({ length: 5 }, (_, i) => i + 1).map((rating) => (_jsxs(RatingBoxContainer, { children: [_jsx(RatingBox, { selected: selectedRating === rating, onClick: () => handleRatingClick(rating), children: rating }), rating === 1 || rating === 5 ? (_jsx(RatingLabel, { children: rating === 1 ? 'Poor' : 'Excellent' })) : null] }, rating))) })] }), _jsxs(HiddenContainer, { isVisible: !!selectedRating, children: [_jsx(HR, {}), _jsx(SubTitle, { children: "Was there anything you either appreciated, or had trouble with, viewing today's service?" }), _jsx(Textarea, { placeholder: "Leave your feedback here", ...register('feedback') }), _jsx(Button, { disabled: isLoading, type: "submit", children: isLoading ? _jsx(Loader, { size: 24, color: "white" }) : 'Submit' })] })] }) }, "feedback-popup"));
};
export default FeedbackPopup;
